export enum RestructuringCellType {
  Attribute = 'Attribute',
  Text = 'Text',
  Matrix = 'Matrix',
  Condition = 'Condition'
}
